let authTypes;
let optionalParams;

export default function RequestAuth(options) {
  if (!options)
    throw new TypeError('Missing options parameter');

  this.options = options;
  this.data = {
  };

  if (!this.options.type)
    throw new TypeError('Missing options.type');

  const authTypeOpts = authTypes[this.options.type];

  if (!authTypeOpts)
    throw new TypeError('Unknown options.type');

  const { container, params } = authTypeOpts;

  if (this.options.type == 'none') {
    this.data.authNone = 1;
    return;
  }

  this.data[container] = {};

  params.forEach(cur => {
    if (this.options[cur] === undefined)
      return;

    this.data[container][cur] = this.options[cur] || '';
  });
}

RequestAuth.setMetadata = function(metadata) {
  authTypes = metadata.types;
  optionalParams = metadata.optional;
};

RequestAuth.getMetadata = function() {
  return {
    authTypes,
    optionalParams,
  };
};

RequestAuth.prototype.getType = function() {
  return this.options.type;
};

RequestAuth.prototype.getData = function() {
  return this.data;
};

// var bstr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
// var aTypes = [ 'account', 'bridge', 'partner', 'operator', 'recording', 'operatorBridge', 'none', 'administrator' ];

// RequestAuth.getAuthTokenType = function(token) {
//   if (token.length < 4)
//     return false;

//   var i = (bstr.indexOf(token.charAt(0)) << 2) | (bstr.indexOf(token.charAt(1)) >> 4);

//   if (i < aTypes.length)
//     return aTypes[i];

//   return false;
// };
